

import { reducersActions } from "../actions/new-actions";

const {
  GET_COLLECTIONS_REQUEST,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTIONS_FAILURE,
} = reducersActions;

const initialState = {
  loading: false,
  collections: [],
  error: null,
  pagination: {
    page: 1,
    totalPages: 0,
    totalItems: 0,
    pageSize: 10,
  },
};

const collectionFilterReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COLLECTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_COLLECTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        collections: action.payload?.data || [],
        pagination: {
          page: action.payload?.currentPage || 1,
          totalPages: action.payload?.totalPages || 0,
          totalItems: action.payload?.totalItems || 0,
          pageSize: action.payload?.total || 10,
        },
      };

    case GET_COLLECTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload || "Something went wrong.",
      };

    default:
      return state;
  }
};

export default collectionFilterReducer;
